import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;

const ConversionUserInfoChartActions = {
    getConversionUserInfo(params, callback) {
        dispatch({
            type: AppConstants.CONVERSION_USER_INFO_START_LOADING
        });

        return api.getConversionUserInfo(params)
            .then(data => {
                dispatch({
                    type: AppConstants.CONVERSION_USER_INFO_SUCCESS,
                    item: data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.CONVERSION_USER_INFO_FAIL,
                        error: err
                    });
                });
            });
    }
};

export default ConversionUserInfoChartActions;
